import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { getImageFromCdn } from '../../../util/ImageUtil';
const ContentListerBanner = ({ image }) => {
    const { imageCdnPrefix } = useAemConfig();
    const getBannerUrl = () => getImageFromCdn(image, imageCdnPrefix, '1680');
    return _jsx(Image, { src: getBannerUrl() });
};
export default ContentListerBanner;
